module.exports = __webpack_public_path__ + "static/media/top_dark_gray.7ceacf83.png";